import "./Navbar.css";
import {Link, useMatch, useResolvedPath, NavLink} from "react-router-dom"

export default function Navbar() {
    return (
        <nav>
            <NavLink to="/" className="not-active" activeClassName="active">
                HOME
            </NavLink>
            <NavLink to="/gallery" className="not-active" activeClassName="active">
                GALLERY
            </NavLink>
            <NavLink to="/about" className="not-active" activeClassName="active">
                SU DI NOI
            </NavLink>
        </nav>
    )
}